import initStore from './initStore';
import thunks from './thunks';
import actions from './actions';

import { IActTeamModel } from './types';

const actTeam: IActTeamModel = {
  ...initStore,
  ...thunks,
  ...actions,
};

export default actTeam;
